export const getTopicsNotHiddenFromNextAndBackNavigation = (topics: any[]) => {
  return topics.filter(topic => {
    // if the topic is hidden from next and back nav. nix it
    const { hiddenFromNextAndBackNavigation } = topic?.props;

    //
    return !hiddenFromNextAndBackNavigation;
  });
};
